const images = {
    griffon: require("./../images/griffon.jpg"),
    pizza: require("./../images/pizza.jpeg")

};

export default images;